import request from '../utils/request';

// 反馈管理API
export const feedbackApi = {
  // 获取反馈列表
  getFeedbackList: (params) => {
    return request({
      url: '/api/feedback/list',
      method: 'get',
      params
    });
  },

  // 获取反馈详情
  getFeedbackDetail: (id) => {
    return request({
      url: `/api/feedback/${id}`,
      method: 'get'
    });
  },

  // 创建反馈
  createFeedback: (data) => {
    return request({
      url: '/api/feedback',
      method: 'post',
      data
    });
  },

  // 更新反馈
  updateFeedback: (id, data) => {
    return request({
      url: `/api/feedback/${id}`,
      method: 'put',
      data
    });
  },

  // 删除反馈
  deleteFeedback: (id) => {
    return request({
      url: `/api/feedback/${id}`,
      method: 'delete'
    });
  },

  // 处理反馈
  processFeedback: (id, data) => {
    return request({
      url: `/api/feedback/${id}/process`,
      method: 'post',
      data
    });
  },

  // 导出反馈
  exportFeedback: (params) => {
    return request({
      url: '/api/feedback/export',
      method: 'get',
      params,
      responseType: 'blob'
    });
  },

  // 获取反馈统计
  getFeedbackStats: (params) => {
    return request({
      url: '/api/feedback/stats',
      method: 'get',
      params
    });
  }
};

// 反馈类型管理API
export const feedbackTypeApi = {
  // 获取反馈类型列表
  getFeedbackTypeList: (params) => {
    return request({
      url: '/api/feedback/types',
      method: 'get',
      params
    });
  },

  // 获取反馈类型详情
  getFeedbackTypeDetail: (id) => {
    return request({
      url: `/api/feedback/types/${id}`,
      method: 'get'
    });
  },

  // 创建反馈类型
  createFeedbackType: (data) => {
    return request({
      url: '/api/feedback/types',
      method: 'post',
      data
    });
  },

  // 更新反馈类型
  updateFeedbackType: (id, data) => {
    return request({
      url: `/api/feedback/types/${id}`,
      method: 'put',
      data
    });
  },

  // 删除反馈类型
  deleteFeedbackType: (id) => {
    return request({
      url: `/api/feedback/types/${id}`,
      method: 'delete'
    });
  }
};

// 举报管理API
export const reportApi = {
  // 获取举报列表
  getReportList: (params) => {
    return request({
      url: '/api/reports/list',
      method: 'get',
      params
    });
  },

  // 获取举报详情
  getReportDetail: (id) => {
    return request({
      url: `/api/reports/${id}`,
      method: 'get'
    });
  },

  // 创建举报
  createReport: (data) => {
    return request({
      url: '/api/reports',
      method: 'post',
      data
    });
  },

  // 更新举报
  updateReport: (id, data) => {
    return request({
      url: `/api/reports/${id}`,
      method: 'put',
      data
    });
  },

  // 删除举报
  deleteReport: (id) => {
    return request({
      url: `/api/reports/${id}`,
      method: 'delete'
    });
  },

  // 审核举报
  auditReport: (id, data) => {
    return request({
      url: `/api/reports/${id}/audit`,
      method: 'post',
      data
    });
  },

  // 处理举报
  processReport: (id, data) => {
    return request({
      url: `/api/reports/${id}/process`,
      method: 'post',
      data
    });
  },

  // 导出举报
  exportReport: (params) => {
    return request({
      url: '/api/reports/export',
      method: 'get',
      params,
      responseType: 'blob'
    });
  },

  // 获取举报统计
  getReportStats: (params) => {
    return request({
      url: '/api/reports/stats',
      method: 'get',
      params
    });
  }
}; 